import { useContext } from 'react';

import {
  DocumentContext,
  type IDocumentContextData,
} from '../contexts/documents';

export const useDocument = (): IDocumentContextData =>
  useContext(DocumentContext);
